import { AxiosPromise } from 'axios'

import api from './api'
import { ScoreResponse, GetAstridScoreOptions } from '@astrid/components'
import { getLanguage } from 'utils'

export const astridGetScore = ({
  audio,
  phrase,
  bookId,
  withoutAuth
}: GetAstridScoreOptions): AxiosPromise<ScoreResponse> => {
  const formData = new FormData()
  formData.append('audio', audio)
  formData.append('target_phrase', phrase)
  formData.append('dialect', getLanguage())
  if (bookId) formData.append('bookId', bookId)

  return api.post(`/astrid${withoutAuth ? '/public' : ''}/score`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
